import { SanityFeatSnippetVideo } from "./FeaturedSnippetModule.d"
import tw from "twin.macro"
import React from "react"
import VideoS3 from "../../molecules/VideoSection/VideoS3"
import ExternalVideo from "../../molecules/VideoSection/ExternalVideo"

const FeaturedSnippetVideo: React.FC<SanityFeatSnippetVideo> = ({
  _key,
  type,
  video_s3,
  externalMedia,
  title,
  styles,
  tealDataFromView,
}) => {
  return (
    <div css={[tw`relative`]} key={_key}>
      {type == "s3" && video_s3 && (
        <VideoS3
          videoSectionHeading={video_s3.asset.title!}
          video_s3={video_s3}
          css={[tw`rounded-none`]}
          autoPlay={true}
          analytics-id={`video:${title}:`}
          extraTealiumValues={tealDataFromView}
        />
      )}
      {type == "youTube" && externalMedia && (
        <ExternalVideo
          videoSectionHeading={null}
          videoSectionVideo={externalMedia}
          autoPlay={true}
          videoCss={[tw`h-1/3 w-full`, tw`md:(h-full w-full)`, styles]}
          analytics-id={`video:${title}:`}
          extraTealiumValues={tealDataFromView}
        />
      )}
    </div>
  )
}
export default FeaturedSnippetVideo
